export default "__VITE_ASSET__D72Qcwbz__"